(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oh-48-banner"] && !Shopify.designMode) return;
  try {
    (() => {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const start = Date.parse(root.dataset.start);
    const end = Date.parse(root.dataset.end);
    let interval;
    function tick() {
      if (!root.isConnected) { clearInterval(interval); return; }
      const now = Date.now();
      const upcoming = now < start;
      const seconds = Math.max(0, Math.floor(((upcoming ? start : end) - now) / 1000));
      root.querySelector('[data-oh48-label]').textContent = now >= end ? 'EDYCJA ZAKOŃCZONA' : upcoming ? 'START EDYCJI ZA' : 'DO KOŃCA TEJ EDYCJI';
      root.querySelector('[data-oh48-clock]').textContent = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(n => String(n).padStart(2, '0')).join(' : ');
      if (now >= end) { clearInterval(interval); if (end && now < Date.parse('2026-11-23T18:00:00Z')) location.reload(); }
    }
    tick();
    if (Date.now() < end) interval = setInterval(tick, 1000);
  }
  function init(){document.querySelectorAll('.oh48-promo').forEach(setup);}
  init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oh-48-product-timer"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    document.querySelectorAll('[data-oh48-product-clock]').forEach(root => {
      if(root.dataset.ready) return;
      root.dataset.ready='true';
      const start=Date.parse(root.dataset.start),end=Date.parse(root.dataset.end);
      let timer;
      function tick(){
        if(!root.isConnected){clearInterval(timer);return;}
        const now=Date.now(),upcoming=now<start,expired=now>=end;
        const remaining=Math.max(0,Math.floor(((upcoming?start:end)-now)/1000));
        root.querySelector('[data-oh48-product-label]').textContent=expired?'Oferta zakończona':upcoming?'Start oferty za':'Do końca oferty';
        root.querySelector('[data-oh48-product-value]').textContent=[Math.floor(remaining/3600),Math.floor(remaining/60)%60,remaining%60].map(n=>String(n).padStart(2,'0')).join(' : ');
        if(expired){clearInterval(timer);if(end&&now<Date.parse('2026-11-23T18:00:00Z'))location.reload();}
      }
      tick();if(Date.now()<end)timer=setInterval(tick,1000);
    });
  }
  init();document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oh-cozy-48-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    document.querySelectorAll('[data-cozy-clock]').forEach(root => {
      if(root.dataset.ready) return;
      root.dataset.ready='true';
      const start=Date.parse(root.dataset.start),end=Date.parse(root.dataset.end);
      let timer;
      function tick(){
        if(!root.isConnected){clearInterval(timer);return;}
        const now=Date.now(),upcoming=now<start,expired=now>=end;
        const remaining=Math.max(0,Math.floor(((upcoming?start:end)-now)/1000));
        root.querySelector('[data-cozy-label]').textContent=expired?'Oferta zakończona':upcoming?'Start oferty za':'Do końca oferty';
        root.querySelector('[data-cozy-value]').textContent=[Math.floor(remaining/3600),Math.floor(remaining/60)%60,remaining%60].map(n=>String(n).padStart(2,'0')).join(' : ');
        if(expired)clearInterval(timer);
      }
      tick();if(Date.now()<end)timer=setInterval(tick,1000);
    });
  }
  init();document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oh-ea-assets"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.documentElement;
  const preview = root.dataset.ohEaPreview === 'true';
  const boot = Date.now();
  let state = root.dataset.ohEaMember === 'true' ? 'member' : 'guest';
  const stateKey = 'oh-honey-early-access-preview-v1';
  const originalPhase = root.dataset.ohEaPhase;
  let lastTrigger;
  const applyState = value => {
    if (!preview) return;
    state = ['guest', 'member', 'ended'].includes(value) ? value : 'guest';
    root.dataset.ohEaMember = String(state === 'member');
    root.dataset.ohEaPhase = state === 'ended' ? 'off' : originalPhase;
    const select = document.querySelector('[data-oh-ea-preview-select]');
    if (select) select.value = state;
    try { sessionStorage.setItem(stateKey, state); } catch {}
  };
  const closeDialog = () => {
    const dialog = document.getElementById('oh-ea-join');
    if (dialog?.open) dialog.close();
    lastTrigger?.focus();
  };
  const openDialog = trigger => {
    const dialog = document.getElementById('oh-ea-join');
    if (!dialog || root.dataset.ohEaPhase === 'off') return;
    lastTrigger = trigger;
    if (!dialog.open) dialog.showModal();
  };
  const tick = () => {
    const clocks = document.querySelectorAll('oh-ea-countdown');
    clocks.forEach(clock => {
      const starts = Date.parse(clock.dataset.start);
      const ends = Date.parse(clock.dataset.end);
      if (!Number.isFinite(starts) || !Number.isFinite(ends)) return;
      const now = preview ? starts + Date.now() - boot : Date.now();
      const target = clock.dataset.phase === 'teaser' ? starts : ends;
      const remaining = Math.max(0, Math.ceil((target - now) / 1000));
      const days = Math.floor(remaining / 86400);
      const hours = Math.floor(remaining % 86400 / 3600);
      const minutes = Math.floor(remaining % 3600 / 60);
      const seconds = remaining % 60;
      const formatted = [days, hours, minutes, seconds].map(n => String(n).padStart(2, '0')).join(' : ');
      const display = clock.querySelector('[data-oh-ea-clock]');
      if (display) display.textContent = formatted;
      clock.setAttribute('aria-label', `${clock.dataset.label}: ${days} d, ${hours} h, ${minutes} min`);
      if (!preview && remaining === 0) {
        if (clock.dataset.phase === 'teaser') {
          location.reload();
        } else {
          root.dataset.ohEaPhase = 'off';
          closeDialog();
        }
      }
    });
  };
  const init = () => {
    if (preview) {
      try { state = sessionStorage.getItem(stateKey) || state; } catch {}
      applyState(state);
    }
    document.addEventListener('click', event => {
      const opener = event.target.closest('[data-oh-ea-open]');
      if (opener) { event.preventDefault(); event.stopPropagation(); openDialog(opener); }
      if (event.target.closest('[data-oh-ea-close]')) closeDialog();
      const dialog = document.getElementById('oh-ea-join');
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog();
      }
    });
    document.addEventListener('change', event => {
      if (event.target.matches('[data-oh-ea-preview-select]')) applyState(event.target.value);
    });
    const dialog = document.getElementById('oh-ea-join');
    dialog?.addEventListener('close', () => lastTrigger?.focus());
    if (document.querySelector('[data-oh-ea-success], [data-oh-ea-form-errors]') || location.hash === '#oh-ea-join') openDialog();
    tick();
    setInterval(() => { if (!document.hidden) tick(); }, 1000);
    document.addEventListener('visibilitychange', tick);
    document.addEventListener('shopify:section:load', tick);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true }); else init();
})();
  } catch(e) { console.error(e); }
})();

})();
